import moment from 'moment'
import {getServerNow} from '../../../utils'

const countdown = (endTime) => {
  var secondPlate = document.getElementById('secondplate')
  var secondCntP = secondPlate.getContext('2d')
  secondPlate.width = 100
  secondPlate.height = 100

  var minutePlate = document.getElementById('minuteplate')
  var minuteCntP = minutePlate.getContext('2d')
  minutePlate.width = 100
  minutePlate.height = 100

  var hourPlate = document.getElementById('hourplate')
  var hourCntP = hourPlate.getContext('2d')
  hourPlate.width = 100
  hourPlate.height = 100

  var dayPlate = document.getElementById('dayplate')
  var dayCntP = dayPlate.getContext('2d')
  dayPlate.width = 100
  dayPlate.height = 100

  function Drawclock (cnt, radius, platelen, linewidth, time) {
    this.cnt = cnt
    this.radius = radius
    this.platelen = platelen
    this.linewidth = linewidth
    this.getCalibCoor = function (i) {
      // 获得表盘刻度两端的坐标
      var X = 50 + this.radius * Math.sin(6 * i * Math.PI / 180)
      var Y = 50 - this.radius * Math.cos(6 * i * Math.PI / 180)
      var x = 50 + (this.radius - this.platelen) * Math.sin(6 * i * Math.PI / 180)
      var y = 50 - (this.radius - this.platelen) * Math.cos(6 * i * Math.PI / 180)

      // 获得分钟数字的坐标
      var numx = 50 + (this.radius - this.platelen - this.numLen) * Math.sin(6 * i * Math.PI / 180)
      var numy = 50 - (this.radius - this.platelen - this.numLen) * Math.cos(6 * i * Math.PI / 180)
      // 获得小时数字的坐标
      var numX = 50 + (this.radius - this.platelen - this.NUMLEN) * Math.sin(6 * i * Math.PI / 180)
      var numY = 50 - (this.radius - this.platelen - this.NUMLEN) * Math.cos(6 * i * Math.PI / 180)
      return {X: X, Y: Y, x: x, y: y, numx: numx, numy: numy, numX: numX, numY: numY}
    }
    this.drawCalibration = function () { // 画刻度
      for (let i = 0, coorObj; i < 60; i++) {
        coorObj = this.getCalibCoor(i)
        this.cnt.beginPath()
        this.cnt.moveTo(coorObj.X, coorObj.Y)
        this.cnt.lineTo(coorObj.x, coorObj.y)
        i < time && (this.cnt.strokeStyle = '#fff')
        i >= time && (this.cnt.strokeStyle = '#565656')
        this.cnt.lineWidth = this.linewidth * 2
        this.cnt.stroke()
      }
    }
    this.drawNumber = function () {
      this.cnt.beginPath()
      this.cnt.font = "60px '300-CAI978'"
      this.cnt.fillStyle = '#00c8e3'
      this.cnt.textAlign = 'center' // 文本水平对齐方式
      this.cnt.textBaseline = 'middle' // 文本垂直方向，基线位置
      this.cnt.fillText(time, 50, 50)
    }
  }
  function draw () {
    const ms = endTime.diff(getServerNow())
    const duration = moment.duration(ms)
    const seconds = duration.seconds() < 10 ? ('0' + duration.seconds()) : duration.seconds()
    const minutes = duration.minutes() < 10 ? ('0' + duration.minutes()) : duration.minutes()
    const hours = duration.hours() < 10 ? ('0' + duration.hours()) : duration.hours()
    const days = duration.days() + duration.months() * 31 < 10 ? ('0' + duration.days()) : duration.days() + duration.months() * 31

    secondCntP.clearRect(0, 0, secondPlate.width, secondPlate.height)
    minuteCntP.clearRect(0, 0, minutePlate.width, minutePlate.height)
    hourCntP.clearRect(0, 0, hourPlate.width, hourPlate.height)
    dayCntP.clearRect(0, 0, dayPlate.width, dayPlate.height)
    var secondClock = new Drawclock(secondCntP, 50, 5, 1, seconds) // 实例化一个表盘对象
    var minuteClock = new Drawclock(minuteCntP, 50, 5, 1, minutes)
    var hourClock = new Drawclock(hourCntP, 50, 5, 1, hours)
    var dayClock = new Drawclock(dayCntP, 50, 5, 1, days)
    secondClock.drawCalibration()
    secondClock.drawNumber()
    minuteClock.drawCalibration()
    minuteClock.drawNumber()
    hourClock.drawCalibration()
    hourClock.drawNumber()
    dayClock.drawCalibration()
    dayClock.drawNumber()
  }
  return setInterval(draw, 1000)
}

export { countdown }



// WEBPACK FOOTER //
// ./src/themes/dragon/utils/index.js